import { schoolReferralFlowAr, schoolReferralFlowEn } from "assets/images";
import { Accordion, type AccordionItem } from "components/shared/Accordion";
import { SchoolSection } from "../components/SchoolSection";
import { SectionTitle } from "../components/SectionTitle";
import { useSchoolLocal } from "../useSchoolLocal";

export const WhyPartner = () => {
  const { t, tObject, isArabic } = useSchoolLocal();

  return (
    <SchoolSection contentClassName="grid items-center gap-10 py-14 md:grid-cols-2 md:py-20">
      <div>
        <SectionTitle className="mb-6">{t("whyPartner.title")}</SectionTitle>
        <Accordion items={tObject<AccordionItem[]>("whyPartner.reasons")} />
      </div>
      <img
        src={isArabic ? schoolReferralFlowAr : schoolReferralFlowEn}
        alt={t("whyPartner.imageAlt")}
        className="mx-auto w-full max-w-[460px]"
      />
    </SchoolSection>
  );
};
